import { zodContract } from '@farfetched/zod';
import { createAuthQuery } from '../auth-http-client';
import { entityWithTitleSchema } from '../types';

export const createGetGamesQuery = () =>
	createAuthQuery({
		request: {
			method: 'GET',
			url: '/games/list/all',
		},
		response: {
			contract: zodContract(entityWithTitleSchema.array()),
		},
	});
